import { Constants } from '@pwc/pwc-deals-web-common';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  viewAnalysisPath,
  reportPreviewPath,
} from 'common/services/urlService';
import { ConnectedContentContextProvider } from 'features/narratives/Context/ConnectedContentContext';
import { getLinksFromNarratives } from 'features/narratives/narrativesUtilities';
import { SyncedInfoProvider } from 'common/components/Autosync/SyncedInfoProvider.tsx';
import { postAnalysis } from '../../analysesService';
import FreeformAnalysisForm from '../FreeformAnalysisForm/FreeformAnalysisForm';
import { SectionsProvider } from '../FreeformAnalysisForm/FreeformAnalysisFormContext';

const parentContentId = -1;

const CreateFreeformAnalysis = () => {
  const { projectId } = useParams();
  const history = useHistory();
  const [connectedContentIsChanged, setConnectedContentIsChanged] =
    useState(false);
  const cancelAndGoBack = () => history.goBack();

  const setConnectedContentChanged = () => {
    setConnectedContentIsChanged(!connectedContentIsChanged);
  };

  const redirectToAnalysisView = (analysisId) => {
    history.replace(viewAnalysisPath(projectId, analysisId));
  };

  const redirectToAnalysisPreview = (analysisId, version) => {
    history.replace(reportPreviewPath(projectId, analysisId, version));
  };

  const handlePostAnalysis = async (
    analysisDto,
    narratives,
    lastSelectedKFA
  ) => {
    analysisDto.links = getLinksFromNarratives(
      narratives,
      parentContentId,
      lastSelectedKFA
    );
    const postAnalysisData = await postAnalysis(projectId, analysisDto);
    return postAnalysisData;
  };

  const publishAction = async (
    analysisDto,
    narratives,
    lastSelectedKFA = null
  ) => {
    const result = await handlePostAnalysis(
      analysisDto,
      narratives,
      lastSelectedKFA
    );
    redirectToAnalysisView(result);
  };

  const previewAction = async (analysisDto, narratives) => {
    const result = await handlePostAnalysis(analysisDto, narratives);
    redirectToAnalysisPreview(result, 'latest');
  };

  const initialSections = [
    {
      order: 1,
      layoutType: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN,
      items: [],
    },
  ];

  const initialCcontextStatusInfoItem = {
    shareWithAll: false,
    userViewStatus: Constants.USER_VIEW_STATUS.NONE.value,
    versionStatus: Constants.VERSION_STATUS.UNDEFINED.value,
    isEditMode: true,
    isViewMode: false,
  };

  return (
    <SectionsProvider value={{ initialSections }}>
      <ConnectedContentContextProvider>
        <SyncedInfoProvider value={initialCcontextStatusInfoItem}>
          <FreeformAnalysisForm
            analysisTitle=""
            analysisBody=""
            analysisInsight=""
            analysis={{}}
            publishAction={publishAction}
            previewAction={previewAction}
            cancelAction={cancelAndGoBack}
            formTitle="Add analysis"
            appliedTags={[]}
            onSaveText="Adding..."
            standbyText="Add analysis"
            sections={initialSections}
            parentContentId={parentContentId}
            setConnectedContentChanged={setConnectedContentChanged}
            isCreateForm
            handleRedirectToView={() => {}}
          />
        </SyncedInfoProvider>
      </ConnectedContentContextProvider>
    </SectionsProvider>
  );
};

export default CreateFreeformAnalysis;
